exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout-root {\n  display: flex;\n  flex-direction: column; }\n\n.content-root {\n  display: flex;\n  flex-direction: row; }\n\n.content {\n  flex-grow: 1;\n  background-color: #E4E5E6;\n  height: calc(100vh - 55px);\n  overflow: auto;\n  margin-left: 240px; }\n\n.no-left-margin {\n  margin-left: 0; }\n\n.content-route {\n  padding: 3.5rem 1rem 1rem 1rem; }\n", ""]);

// exports
